import { removeSparkolCookies } from 'js/shared/helpers/TokenHelper';

import { cognitoSignOut } from './authHelper';

export async function logOutAndReload() {
  removeSparkolCookies();
  await cognitoSignOut();
  window.location.reload();
}
